import React from "react";
import type { IAsset } from "@api/IWalletController";
import type { IPortfolioItem } from "@stores/wallet.store";

interface CurrencyItemProps {
    asset: IAsset;
    portfolioItem?: IPortfolioItem;
    onSelect: (asset: IAsset) => void;
}

// Функция для форматирования баланса
const formatBalance = (balance: number): string => {
    if (balance >= 1000000) {
        return `${(balance / 1000000).toFixed(1)}m`;
    } else if (balance >= 1000) {
        return `${(balance / 1000).toFixed(1)}k`;
    }

    if (balance === 0) {
        return "";
    }

    return balance.toFixed(5);
};

const CurrencyItem: React.FC<CurrencyItemProps> = ({ asset, portfolioItem, onSelect }) => {
    // Получаем баланс с учетом специфики TON
    const balance = asset.jettonMasterAddress === "ton" ? (portfolioItem?.balance ?? 0) : (portfolioItem?.balance ?? 0);

    // Форматируем баланс для отображения
    const formattedBalance = formatBalance(balance);

    // Полный баланс для тултипа
    const fullBalance = balance.toFixed(5);

    return (
        <button
            key={asset.jettonMasterAddress}
            onClick={() => onSelect(asset)}
            className="w-full flex items-center p-3 rounded-2xl border hover:bg-muted-foreground/30 hover:border-muted-foreground cursor-pointer transition duration-150 ease-in-out space-x-3 text-left max-w-full"
        >
            <div className="flex-shrink-0 h-10 w-10">
                <img
                    height={42}
                    width={42}
                    src={asset.image || "/placeholder.svg"}
                    alt={`${asset.symbol} logo`}
                    className="rounded-full h-full w-full"
                    onError={(e) => {
                        const jettonFallback = "/images/jettonFallback.svg";
                        if ((e.target as HTMLImageElement).src !== jettonFallback) {
                            (e.target as HTMLImageElement).src = jettonFallback;
                        }
                    }}
                />
            </div>
            <div className="flex-grow">
                <div className="text-sm font-medium text-white truncate">{asset.name || "Unknown Name"}</div>
                <div className="text-xs text-gray-400 truncate">{asset.symbol || "---"}</div>
            </div>
            <div
                className="text-sm text-right text-gray-300 text-xs"
                title={fullBalance} // Показываем полный баланс в тултипе
            >
                {formattedBalance}
            </div>
        </button>
    );
};

export default CurrencyItem;
